import { useContext } from 'react'
import { useIntl } from 'react-intl'

import { ConfirmationDialog } from '../../../ui'
import { ModalContext } from '../../../ui/modal/contexts'
import { AddTarifaDialog } from '../dialogs/add-tariffs-to-ca-dialog.component'

export const useTariffsDialogs = () => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useContext(ModalContext)

  const warnPermanentDeletion = (callback) => {
    open({
      Component: ConfirmationDialog,
      data: {
        title: formatMessage({ id: 'pages.tariffs.table.warning.permanent.title' }),
        text: formatMessage({ id: 'pages.tariffs.table.warning.permanent.text' }),
        yesText: formatMessage({ id: 'pages.tariffs.table.warning.permanent.yes' }),
        noText: formatMessage({ id: 'pages.tariffs.table.warning.permanent.no' }),
        yesAction: callback,
      },
    })
  }

  const showAddTarifaDialog = ({ comunidades, onAccept }) => {
    open({
      Component: AddTarifaDialog,
      data: { comunidades, onAccept },
      maxWidth: 'sm',
    })
  }

  return {
    warnPermanentDeletion: warnPermanentDeletion,
    showAddTarifaDialog: showAddTarifaDialog,
  }
}
